<template>
  <div class="c-note">
    <div class="c-note__content">
      <div class="c-note__quote"><p class="c-note__highlight"><span>...</span> {{ quote }} <span>...</span></p></div>
      <div class="c-note__page">{{ page }}</div>
    </div>
    <div class="c-note__text"><p>{{ text }}</p></div>
    <div class="c-note__date">{{ date | formatDate }}</div>
  </div>
</template>

<script>
export default {
  name: 'Note',

  props: {
    quote: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    page: {
      type: Number,
      default: null
    },
    date: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';

.c-note {
  width: 100%;
  padding: 1.3em 0 1.8em;
  position: relative;
  &:hover:after {
    content: '';
    position: absolute;
    left: -1.8em;
    right: -1.8em;
    bottom: 0;
    top: 0;
    background: rgba($light-grey-blue, 0.2);
    border-radius: 2em;
  }
}

.c-note__content {
  display: flex;
  flex-direction: row;
}

.c-note__quote {
  color: $dark-blue;
  font-size: 1em;
  margin: 0 1em 1.3em 0;
}

.c-note__highlight {
  display: inline;
  font-style: italic;
  background-color: $violet;
  font-weight: 300;
  line-height: 1em;
}

.c-note__page {
  font-weight: 500;
  color: $dark-blue;
  margin-left: auto;
  height: 18px;
  line-height: 1em;
}

.c-note__text {
  color: $black;
  font-size: 1em;
  margin-bottom: 1.5em;
}

.c-note__date {
  font-size: 12px;
  font-weight: 300;
  text-align: right;
  color: $dark-blue;
}
</style>
